import { useLang, translations } from "../i18n";

export function Footer() {
  const { lang } = useLang();

  return (
    <footer className="bg-[var(--background-dark)] text-white/30 text-[12px] font-medium py-8 px-6 md:px-12 border-t border-white/[0.06]">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="flex items-center gap-4">
          <span className="text-white/60 font-bold text-sm">
            Vilverin<span className="text-[var(--primary)]">.</span>
          </span>
          <span>&copy; 2026 Vilverin</span>
        </div>
        <span>{translations.footer.location[lang]}</span>
      </div>
    </footer>
  );
}
